
export default function ServiceAreasSection() {
  const areas = [
    'La Jolla',
    'Del Mar',
    'Carlsbad',
    'Encinitas',
    'Downtown San Diego',
    'Coronado',
    'Pacific Beach',
    'Mission Valley',
    'Rancho Bernardo',
    'Poway',
    'Escondido',
    'Chula Vista'
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Serving All of San Diego County
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We proudly provide photo booth and overhead 360 video booth rentals throughout San Diego County 
            and surrounding areas.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-12">
          {areas.map((area, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-lg p-4 text-center hover:bg-teal-50 transition-colors"
            >
              <i className="ri-map-pin-line text-2xl text-teal-600 mb-2"></i>
              <p className="text-gray-900 font-medium">{area}</p>
            </div>
          ))}
        </div>

        <div className="bg-teal-50 rounded-xl p-8 text-center">
          <p className="text-lg text-gray-700">
            <strong className="text-gray-900">Don't see your area?</strong> We service many more locations 
            throughout Southern California. Contact us to check availability for your event!
          </p>
        </div>
      </div>
    </section>
  );
}
